<template>
  <teleport to="body">
    <transition name="fade">
      <div v-if="isModalOpen" class="fixed top-0 left-0 md:p-15 w-full h-full bg-backdrop flex justify-center items-center z-100"
           @click.self="$emit('close')"
      >
        <div ref="modalContent" class="relative bg-primary w-full h-full max-w-1220 md:max-h-750 md:rounded-4 overflow-hidden">
          <ButtonModule
            prefix="icon-close"
            :has-hover="true"
            class="absolute top-20 right-20 text-18 text-app-color cursor-pointer"
            @click="$emit('close')"
          />

          <div class="h-full">
            <slot />
          </div>
        </div>
      </div>
    </transition>
  </teleport>
</template>

<script>
import { preventBodyScroll } from '@/core/helper-functions'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

export default {
  name: 'Modal',

  components: { ButtonModule },

  props: {
    isModalOpen: { type: Boolean }
  },

  emits: ['close'],

  watch: {
    isModalOpen (value) {
      preventBodyScroll(value)
    }
  }
}
</script>
